import FiltersContainer from "./FiltersContainer";

export default FiltersContainer;